class Index {
    constructor(api, slug) {
        this.api = api;
        this.slug = slug;
    }

    find(item) {
        let route = null;
        if (this.slug === 'films') {
            route = this.api.route('film.json', {
                index: this.slug,
                film: item,
            });
        }
        return route !== null
            ? this.api.requestGet(route, null, {
                  withSession: true,
              })
            : new Promise();
    }

    get(query = {}, route = null) {
        const finalQuery = {
            ...query,
        };
        const finalRoute =
            route === null
                ? this.api.route('index.json', {
                      index: this.slug,
                  })
                : route;

        return this.api.requestGet(finalRoute, finalQuery, {
            withSession: true,
        });
    }

    getRelated(related, query = {}, count = 10) {
        const finalQuery = {
            ...query,
            count,
        };
        return this.api.requestGet(
            this.api.route('index.related.json', {
                index: this.slug,
                item: related.slug,
            }),
            finalQuery,
            {
                withSession: true,
            },
        );
    }
}

export default Index;
